import React, { Component } from "react";
import { connect } from "react-redux";
import { openModalDebitComp } from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import CardBankGroup from "../../components/CardBankGroup";
import ButtonOK from "../../components/ButtonOK";
import { getBanks } from "../../helper/getBanks";

const styles = (theme) => ({
  gridItem: {
    padding: 15,
  },
  message: {
    width: "100%",
    fontSize: "1.5rem",
  },
  content: {
    display: "flex",
  },
});

class PaymentCard extends Component {
  state = {
    banks: [],
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });

    let returnBanks = getBanks(3);
    returnBanks.then((response) => {
      this.setState({
        banks: response,
        loading: false,
      });
    });
  }

  render() {
    const { classes } = this.props;
    const { banks } = this.state;

    return (
      <div>
        <Grid className={classes.content}>
          <Grid item xs={12} sm={4} md={5} className={classes.gridItem}>
            {/* <ButtonBack link={"/"} /> */}

            <Typography
              variant="h5"
              component="h3"
              color="textSecondary"
              className={classes.message}
            >
              <p>
                Você pode pagar o DAM em qualquer uma das agências indicadas ao
                lado, assim como seus correspondentes bancários.
              </p>
            </Typography>
            <ButtonOK />
          </Grid>

          <Grid item xs={12} sm={8} md={7} className={classes.gridItem}>
            <Typography variant="h6" component="h4" color="textSecondary">
              PAGAMENTO <strong>DAM</strong>
            </Typography>

            <Grid container>
              <CardBankGroup
                typeCard={"dam"}
                banks={banks}
                staticLogoDam={true}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ openModalDebitComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(PaymentCard)
);
